import { render, staticRenderFns } from "./IncidencesMobileList.vue?vue&type=template&id=65841870&"
import script from "./IncidencesMobileList.vue?vue&type=script&lang=js&"
export * from "./IncidencesMobileList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports